import { AvailableModules, Features } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { ProjectsUpsellRequestSources } from '../constants'
import { useCreateUpsellNotificationMessage } from '../hooks/useCreateUpsellNotificationMessage'

interface RequestUpgradeModalProps {
  moduleRequested: AvailableModules
  onClose: () => void
  originProjects?: boolean
}

export const UpsellSalesInvoiceFeatureModal = ({
  onClose,
  moduleRequested,
  originProjects = false,
}: RequestUpgradeModalProps) => {
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()

  const onCloseUpsellModal = () => {
    track(trackingEvents.projectManagement.salesInvoices.upsellModal.cancelUpsellModal, {
      origin: originProjects ? 'Projects' : 'Invoices',
    })
    onClose()
  }

  const onSuccessNotify = async () => {
    track(trackingEvents.projectManagement.salesInvoices.upsellModal.confirmUpsellModal, {
      origin: originProjects ? 'Projects' : 'Invoices',
    })
    sendUpsellNotificationMessage(ProjectsUpsellRequestSources.projectSalesInvoices)
  }

  return (
    <RequestUpgradeModal
      moduleRequested={moduleRequested}
      featureRequested={Features.sales_invoices_creation}
      requestReason={ValidReasons.MissingAddon}
      requestSource={`Sales Invoice Feature Modal ${originProjects ? 'Projects' : 'Invoices'}`}
      onClose={onCloseUpsellModal}
      onSuccess={onSuccessNotify}
      title={i18n.t('project_management.sale_invoices.upselling.title')}
      description={i18n.t('project_management.sale_invoices.upselling.description')}
      customSuccessDescription={i18n.t(
        'project_management.sale_invoices.upselling.success_description'
      )}
    />
  )
}
